import { Guid } from '@web/utils';

export class PublicOrderInvoice {
  public constructor(
    private readonly data: {
      id: Guid;
      number: string;
    },
  ) {}

  public get id(): Guid {
    return this.data.id;
  }

  public get number(): string {
    return this.data.number;
  }
}
